var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreMps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 3,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7925 25C32.7925 23.9 33.6631 23.0114 34.7406 23.0114C35.8181 23.0114 36.6886 23.9 36.6886 25C36.6886 26.1 35.8181 26.9886 34.7406 26.9886C33.6631 26.9886 32.7925 26.1 32.7925 25ZM23.0523 25C23.0523 23.9 23.9228 23.0114 25.0003 23.0114C26.0778 23.0114 26.9484 23.9 26.9484 25C26.9484 26.1 26.0778 26.9886 25.0003 26.9886C23.9228 26.9886 23.0523 26.1 23.0523 25ZM17.2081 25C17.2081 26.1 16.3358 26.9886 15.2601 26.9886C14.1844 26.9886 13.312 26.1 13.312 25C13.312 23.9 14.1844 23.0114 15.2601 23.0114C16.3358 23.0114 17.2081 23.9 17.2081 25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreMps);
export default __webpack_public_path__ + "static/media/more_mps.482bdd0cde8ddb026a79ff673eed14ac.svg";
export { ForwardRef as ReactComponent };